import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ExpandMenuDirective } from './expand-menu.directive';
import { ClickOutsideComponentDirective } from './click-outside-component.directive';
import { AutofocusDirective } from './autofocus.directive';
import { DefaultImageDirective } from './default-image.directive';
import { FileUploadDirective } from './file-upload.directive';
import { IsEllipsisActiveDirective } from './is-ellipsis-active.directive';
import { CustomValidatorDirective } from './custom-validator.directive';
import { BtcWalletValidatorDirective } from './btc-wallet-validator.directive';
import { OnlyNumbersInputDirective } from './only-numbers-input.directive';
import { OnlyDateInputDirective } from './only-date-input.directive';
import { AddWidgetDirective } from './add-widget.directive';
import { AddDisabledClassDirective } from './add-disabled-class.directive';
import { GrabCursorDirective } from './grab-cursor.directive';
import { ControlValueAccessorDirective } from './control-value-accessor.directive';
import { TextareaAutosizeDirective } from './textarea-autosize.directive';
import { SwiperDirective } from './swiper.directive';

@NgModule({
  declarations: [
    ExpandMenuDirective,
    ClickOutsideComponentDirective,
    AutofocusDirective,
    DefaultImageDirective,
    FileUploadDirective,
    IsEllipsisActiveDirective,
    CustomValidatorDirective,
    BtcWalletValidatorDirective,
    OnlyNumbersInputDirective,
    OnlyDateInputDirective,
    AddWidgetDirective,
    AddDisabledClassDirective,
    GrabCursorDirective,
    ControlValueAccessorDirective,
    TextareaAutosizeDirective,
    SwiperDirective
  ],
  imports: [CommonModule],
  exports: [
    ExpandMenuDirective,
    ClickOutsideComponentDirective,
    AutofocusDirective,
    DefaultImageDirective,
    FileUploadDirective,
    IsEllipsisActiveDirective,
    OnlyNumbersInputDirective,
    AddWidgetDirective,
    AddDisabledClassDirective,
    GrabCursorDirective,
    TextareaAutosizeDirective,
    SwiperDirective
  ]
})
export class DrirectivesModule {}
